import { Box, Typography } from '@mui/material';
import {
  ChevronLeftRounded,
  ChevronRightRounded,
  ImportExport,
} from '@mui/icons-material';
import { Link } from 'components/lib';
import React, { ReactElement } from 'react';

export interface PaginatorProps {
  page: number;
  pageSize: number;
  total: number;
  onChangePage: (page: number) => void;
  onClickExport?: () => void;
}

export const Paginator = ({
  page,
  pageSize,
  total,
  onChangePage,
  onClickExport,
}: PaginatorProps): ReactElement => {
  const numPages = Math.ceil(total / pageSize);
  return (
    <Box display="flex" alignItems="center" lineHeight={0}>
      <Box
        tabIndex={0}
        sx={{
          padding: 2,
          cursor: 'pointer',
          color: page <= 1 ? '#c4c4c4' : '#fff',
          background: theme =>
            page <= 1 ? '#eaeaea' : theme.palette.primary.main,
        }}
        className="keyboardFocus"
        onClick={() => page > 1 && onChangePage(page - 1)}
        onKeyPress={(e: React.KeyboardEvent) => {
          if (e.key === ' ') {
            e.preventDefault();
            page > 1 && onChangePage(page - 1);
          }
        }}
      >
        <ChevronLeftRounded style={{ fontSize: 21.5 }} />
      </Box>
      <Box minWidth={100} px={10} textAlign="center">
        <Typography sx={{ fontSize: '0.875em' }}>
          {`${total > 0 ? (page - 1) * pageSize + 1 : 0} - ${Math.min(
            total,
            page * pageSize,
          )}`}
        </Typography>
      </Box>
      <Box
        tabIndex={0}
        sx={{
          padding: 2,
          cursor: 'pointer',
          color: page >= numPages ? '#c4c4c4' : '#fff',
          background: theme =>
            page >= numPages ? '#eaeaea' : theme.palette.primary.main,
        }}
        className="keyboardFocus"
        onClick={() => page < numPages && onChangePage(page + 1)}
        onKeyPress={(e: React.KeyboardEvent) => {
          if (e.key === ' ') {
            e.preventDefault();
            page < numPages && onChangePage(page + 1);
          }
        }}
      >
        <ChevronRightRounded style={{ fontSize: 21.5 }} />
      </Box>
      <Box ml={30} fontSize="0.875em">
        {total} Record{total !== 1 && 's'}
      </Box>
      {onClickExport && (
        <Link onClick={onClickExport}>
          <Box
            ml={20}
            display="flex"
            alignItems="center"
            fontSize="0.875em"
            fontWeight={600}
          >
            <ImportExport />
            <Box ml={4}>Export As CSV</Box>
          </Box>
        </Link>
      )}
    </Box>
  );
};
